
import PropTypes from 'prop-types'
import Box from '@mui/material/Box'

const logoVariants = {
  default: 'default',
  light: 'light',
  leftDark: 'leftDark',
  marketingLogo: 'marketingLogo',
}

const Brand = ({ className, variant, ...props }) => {

  return (
    <Box
      sx={{
        display: 'flex',
        width: 207,
        height: 50,
        backgroundSize: 'cover',
        backgroundRepeat: 'no-repeat',
        backgroundPosition: 'center',
        backgroundImage: variant === logoVariants.light ? 'url("/static/images/logo-light.png")' : 'url("/static/images/logo.png")',
        ...className
      }}
      {...props}/>
  )
}

Brand.propTypes = {
  className: PropTypes.string,
  variant: PropTypes.oneOf(['default', 'leftDark', 'marketingLogo']),
}

export default Brand
